import { COUNTRIES_API_URL, SERVER_URL } from "../Consts/config";
import { get } from ".";

const getCountries = async () =>
  await get(`${SERVER_URL}${COUNTRIES_API_URL}`, {});

export { getCountries };
